/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createRandomInt } from '../../factoriesAny.js';
export var randomIntDependencies = {
  typedDependencies,
  createRandomInt
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesRandomInt.generated.js
// module id = null
// module chunks = 